// import objects
import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import {languageCurrent} from './i18n';

// use vuex
Vue.use(Vuex);

// state object
const state = {
	// current language
	languageCurrent: languageCurrent(),

	// array of project features
	aboutFeatures: [],

	// object for server data
	statusServer: {},

	// credentials for connection to server
	statusCredentials: {}
};

// mutations
const mutations = {
	/**
	 * Set language.
	 * @param {Object} state state object
	 * @param {Object} payload mutation payload object (i18n and language props)
	 */
	languageSet: function(state, payload) {
		// update current language
		state.languageCurrent = payload['language'];
		payload['i18n'].locale = payload['language'];
	},



	/**
	 * Update features array used in 'About' section.
	 * @param {Object} state state object
	 * @param {Array} payload features array
	 */
	aboutFeaturesUpdate: function(state, payload) {
		state.aboutFeatures = payload;
	},



	/**
	 * Update server status object.
	 * @param {Object} state state object
	 * @param {Array} payload status object
	 */
	statusServerUpdate: function(state, payload) {
		state.statusServer = payload;
	},



	/**
	 * Update server credentials object.
	 * @param {Object} state state object
	 * @param {Array} payload credentials object
	 */
	statusCredentialsUpdate: function(state, payload) {
		state.statusCredentials = payload;
	}
};

// actions
const actions = {
	/**
	 * Set language.
	 * @param {Function} commit callback function
	 * @param {Object} payload mutation payload object (i18n and language props)
	 */
	languageSet({commit}, payload) {
		commit('languageSet', payload);
	},



	/**
	 * Load language translations and set a new language.
	 * @param {Function} commit callback function
	 * @param {Object} payload mutation payload object (i18n and language props)
	 * @returns {Promise<void>}
	 */
	async languageSetNew({commit}, payload) {
		// detect if this language was already loaded
		if (payload['language'] in payload['i18n'].messages) {
			// change current language
			commit('languageSet', payload)
		} else {
			// try to load the language translations
			try {
				// load translations
				const res = await axios.get(`../../static/languages/${payload['language']}.json`);

				// add language translations to messages object
				payload['i18n'].setLocaleMessage(payload['language'], res.data);

				// change language
				commit('languageSet', payload);
			} catch(e) {
				console.error(e);
			}
		}
	},



	/**
	 * Get features and call mutation to update the correspondent array.
	 * @param {Function} commit callback function
	 * @param {String} [language] language
	 * @returns {Promise<void>}
	 */
	async aboutFeaturesUpdate({commit}, language) {
		// get language
		if ('undefined' === typeof language || null === language) {
			language = state.languageCurrent;
		}

		// try to update project features
		try {
			const res = await axios.get(`https://stats.wogames.info/json/features.json?project=5&language=${language}`);
			commit('aboutFeaturesUpdate', res.data);
		} catch(e) {
			commit('aboutFeaturesUpdate', []);
			console.error(e);
		}
	},



	/**
	 * Get server status data and call mutation to update the correspondent array.
	 * @param {Function} commit callback function
	 * @param {Number} project project id (6 for WOG)
	 * @returns {Promise<void>}
	 */
	async statusServerUpdate({commit}, project = 6) {
		// try to update project features
		try {
			const res = await axios.get(`https://wogames.info:8081/status/GetServerStatus?idKey=${project}`);
			commit('statusServerUpdate', res.data);
		} catch(e) {
			commit('statusServerUpdate', {});
			console.error(e);
		}
	},



	/**
	 * Get server credentials and call mutation to update the correspondent array.
	 * @param {Function} commit callback function
	 * @param {Number} project project id (6 for WOG)
	 * @returns {Promise<void>}
	 */
	async statusCredentialsUpdate({commit}, project = 6) {
		// try to update project features
		try {
			// get server credentials
			const res = await axios.get('https://wogames.info:8081/status/GetServers');
			const credentials = res.data;

			// loop through object and get the specified project credentials
			const projects = credentials.length;
			for (let i = 0; i < projects; i++) {
				// detect if project id matches the argument
				if (project === credentials[i]['id']) {
					commit('statusCredentialsUpdate', credentials[i]);
					return;
				}
			}

			// default result
			commit('statusCredentialsUpdate', {});
		} catch(e) {
			commit('statusCredentialsUpdate', {});
			console.error(e);
		}
	}
};

// export store
export default new Vuex.Store({state, mutations, actions});


// WEBPACK FOOTER //
// ./src/store.js